import { User } from "shared/datamodel/schemas/user";
import { isBasicPlan } from "shared/util/billing";
import { flattenObjectRecursive } from "shared/util/utils";

export function getAdminIds(users: Map<number, User>): number[] {
  const adminUserIds: number[] = [];
  users.forEach((user: User, userId: number) => {
    if (user.isAdmin) {
      adminUserIds.push(userId);
    }
  });
  return adminUserIds;
}

export function getDomain(email: string) {
  return email.slice(Math.max(0, email.indexOf("@") + 1));
}

export function prepareAccountObjectForAnalytics(user: User) {
  return {
    ...user.account,
    seatsCount: user.planInfo?.seats_count,
    isFree: isBasicPlan(user.planInfo?.plan_id),
    planId: user.planInfo?.plan_id,
    isDowngraded: user.planInfo?.is_downgraded,
  };
}

export function prepareUserObjectForAnalytics(user: User) {
  const clonedUser = structuredClone(user);
  delete clonedUser.repsToken;
  delete clonedUser.serialNumber;
  delete clonedUser.planInfo?.enc_features;

  return flattenObjectRecursive({ ...clonedUser, account: prepareAccountObjectForAnalytics(clonedUser) });
}
